import { callApi } from '@local_modules/generic/fetch.js'

//
export async function loadChartOfAccounts (appAccountId) {
  const apiUrl = '/api/xero-accounting/by-account/:appAccountId/chart-of-accounts'
  const data = await callApi(apiUrl, {
    appAccountId
  })
  console.log('loadChartOfAccounts', data)

  return data
}
